import { Grid, Fade, CircularProgress } from "@material-ui/core";
import React, { useRef, useState } from "react";
import useStyles from "../../../../../styles";
import Avatar from "@material-ui/core/Avatar";
import { useDispatch, useSelector } from "react-redux";
import useOnClickOutside from "../../../../../utilize/Hook/useOutSideClick";
import { logOut } from "../../../../../routes/actions";
import exitIcon from "assets/icon/exitIcon.svg";
import resetPassword from "assets/icon/resetPassword.svg";
import history from "../../../../../utilize/history";
import { Link } from "react-router-dom";
import Apis from "../../../../../constants/Api";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";

export default function ProfileSection() {
  const classes = useStyles();
  const [fadeState, setFadeState] = useState(false);
  const dispatch = useDispatch();
  const { exitLoading, currentUser } = useSelector((state) => state.main);
  const handleClick = () => {
    setFadeState(!fadeState);
  };
  const profileFadeSection = useRef(null);
  useOnClickOutside(profileFadeSection, () => {
    setFadeState(false);
  });
  const checkUrl = (url) => {
    // axios
    //     .get(Apis.baseUrl + `a/act${url}`, {
    //         headers: {
    //             Authorization: `token ${localStorage.getItem("aghighToken")}`,
    //         },
    //     })
    // .then((res) =>
    history.push(`/associations${url}`);
    //  )
    // .catch((err) => history.push("/not-found"));
  };
  return (
    <Grid
      container
      alignItems="center"
      style={{ position: "relative", cursor: "pointer" }}
      ref={profileFadeSection}
      onClick={handleClick}
    >
      <span className={classes.nameText}>{currentUser.name}</span>
      <Avatar
        alt="Remy Sharp"
        src={currentUser.photo && Apis.imageUrl + currentUser.photo}
        className={classes.profileAvatar}
      />
      <Fade in={fadeState} ref={profileFadeSection}>
        <Grid
          container
          style={{
            width: "fit-content",
            position: "absolute",
            top: 80,
            left: 14,
          }}
        >
          <Grid item className={classes.rectangle} />
          <Grid item className={classes.ProfileContainer}>
            <Grid
              container
              wrap="nowrap"
              alignItems="center"
              className={classes.nameContainer}
              style={{ backgroundColor: "#e4e4e4" }}
              component={Link}
              to={`/profile/${currentUser.slug}`}
            >
              <PermIdentityIcon className={classes.userIcon} />
              <span style={{ fontSize: 14, fontWeight: "bold" }}>
                پروفایل من
              </span>
            </Grid>
            <Grid
              container
              wrap="nowrap"
              alignItems="center"
              className={classes.nameContainer}
              style={{ backgroundColor: "#fff" }}
              component={Link}
              to={`/change-password`}
            >
              <img
                src={resetPassword}
                alt="resetPassword"
                className={classes.resetPasswordIcon}
              />
              <span style={{ fontSize: 14, fontWeight: "bold" }}>
                تغییر رمز عبور
              </span>
            </Grid>
            {currentUser?.roles?.map((item, index) => {
              return (
                <Grid
                  container
                  wrap="nowrap"
                  alignItems="center"
                  className={`${classes.nameContainer} anjoman_url`}
                  key={index + Date.now()}
                  onClick={() => checkUrl(item.url)}
                >
                  <span style={{ fontSize: 14 }}>
                    {item.role + " " + item.unit}
                  </span>
                </Grid>
              );
            })}
            {exitLoading ? (
              <CircularProgress />
            ) : (
              <Grid
                container
                alignItems="center"
                direction="column"
                justify="center"
                className={classes.exitContainer}
                onClick={() => {
                  localStorage.removeItem("aghighToken");
                  dispatch(logOut());
                  history.push("/");
                }}
              >
                <img src={exitIcon} style={{ width: 30 }} alt="exitIcon" />
                <span className={classes.exitText}>خروج</span>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Fade>
    </Grid>
  );
}
